import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SecretKeyInterceptor } from './interceptors/secret-key.interceptor';
import { SharedUtilDomModule } from '@mode/shared/util-dom';
import { CustomHeaderInterceptor } from './interceptors/custom-header.interceptor';
import { ApiErrorLoggingInterceptor } from './interceptors/api-error-logging.interceptor';
import { LegacyDatasetInterceptor } from './interceptors/legacy-dataset.interceptor';
import { PreloadInterceptor } from './interceptors/preload.interceptor';
import { TemplateParser, TEMPLATE_PARSER, DualDispatchUriTemplateService } from '@mode/shared/util-halogen';

@NgModule({
  imports: [CommonModule, SharedUtilDomModule],
  providers: [
    { provide: TEMPLATE_PARSER, useClass: DualDispatchUriTemplateService },
    { provide: HTTP_INTERCEPTORS, useClass: CustomHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SecretKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorLoggingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LegacyDatasetInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PreloadInterceptor, multi: true },
  ],
})
export class SharedDataAccessWebappModule {}
